import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ConfigStore } from '../../stores/config.store';

@Component({
  selector: 'page-config',
  templateUrl: 'config.html',
})
export class ConfigPage {

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private store: ConfigStore) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad Config');
  }

  ionViewWillLeave() {      
      if (this.store)
          this.store.save();
  }

}



// WEBPACK FOOTER //
// ./src/pages/config/config.ts